import http from "../http";
import Service from "../../Service";

/**
 * @type PaymentService
 */
export default class PaymentService extends Service {
    list(params) {
        return http.get(`/admin/management/terms`, {
            headers: this.getHeaders(),
            params
        });
    }
    create(data) {
        return http.post(`/admin/management/terms`, data, {
            headers: this.getHeaders()
        });
    }
    update(id, data) {
        return http.put(`/admin/management/terms/${id}`, data, {
            headers: this.getHeaders()
        });
    }
    delete(id) {
        return http.delete(`/admin/management/terms/${id}`, {
            headers: this.getHeaders(),
        });
    }
}
